<template>
  <v-alert outline class="ma-0" color="warning" :value="mensagem">
    <div class="title mb-1">Importante</div>
    <div v-html="mensagem"></div>
  </v-alert>
</template>

<script>
import { getParametro } from "@/services/beneficiario";

export default {
  name: "MensagemAnexo",
  props: {
    parametroId: Number
  },
  data() {
    return {
      mensagem: null,
      title: null
    };
  },
  created() {
    this.getParametroMensagem();
  },
  methods: {
    async getParametroMensagem() {
      if (this.parametroId) {
        this.mensagem = await getParametro(this.parametroId).then(response =>
          response.replaceAll("<p>", '<p class="mb-0">')
        );
      }
    }
  }
};
</script>
